<template>
    <BasePromotionCard
        v-if="!data.already_integrated"
        title="Connect your calendar"
        description="Connect Google or Outlook so I can prep you for upcoming meetings and surface follow-ups."
        cta-label="Connect calendar"
        cta-href="/calendar_integration/">
        <template #icon>
            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
        </template>
    </BasePromotionCard>
    <div v-else class="max-w-[80%] rounded-md border border-slate-200 bg-white px-3 py-2 text-xs text-slate-500">Calendar already connected — no action needed.</div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { PromoteCalendarIntegrationResult } from "../../types";
import BasePromotionCard from "./BasePromotionCard.vue";

const props = defineProps<{ result: PromoteCalendarIntegrationResult; toolName: string }>();

const data = computed<PromoteCalendarIntegrationResult>(() => props.result);
</script>
